import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { devices } from '../../../const/devices';

export const Container = styled.div`
	width: 100%;
	min-height: 100%;
	display: grid;
	place-items: center;
	position: relative;

	@media ${devices.tablet} {
		place-items: center stretch;
	}
`;

const circle = css`
	position: absolute;
	border-radius: 50%;
`;

export const YellowCircle = styled.div`
	${circle}
	background: #EBCA53;
	width: 350px;
	height: 350px;
	top: -86px;
	left: -206px;

	@media ${devices.tablet} {
		width: 200px;
		height: 200px;
		top: -36px;
		left: -166px;
	}
`;

export const BlueCircle = styled.div`
	${circle}
	width: 450px;
	height: 450px;
	top: -256px;
	right: -241px;
	rotate: -4deg;
	background: rgb(90, 120, 189);
	background: radial-gradient(circle, rgba(90, 120, 189, 1) 0%, rgba(58, 89, 161, 1) 100%);

	@media ${devices.tablet} {
		width: 160px;
		height: 160px;
		top: -86px;
		right: -96px;
	}
`;

export const GreenCircle = styled.div`
	${circle}
	width: 200px;
	height: 200px;
	top: -106px;
	left: 64px;
	background-color: #53e8b3;

	@media ${devices.tablet} {
		width: 130px;
		height: 130px;
		top: -106px;
		left: -16px;
	}
`;

export const FormWrapper = styled.div`
	display: flex;
	border-radius: 8px;
	box-shadow: 0px 4px 6px 0px #0000001a;
	overflow: hidden;
	position: relative;
	z-index: 2;
	background-color: #fff;
	margin-top: 50px;
	min-height: 725px;

	@media ${devices.tablet} {
		background-color: transparent;
		box-shadow: none;
		min-height: auto;
	}
`;

export const FormContainer = styled.div`
	padding: 30px 60px 50px;
	display: flex;
	flex-direction: column;
	width: 450px;

	@media ${devices.laptop} {
		padding: 30px;
	}

	@media ${devices.tablet} {
		width: 100%;
		max-width: 400px;
		margin: auto;
		padding: 30px 0;
	}
`;

export const LandingPageImage = styled.img`
	width: 100%;
	min-height: 100%;
	max-width: 600px;
	overflow: hidden;

	object-fit: cover;

	@media ${devices.laptop} {
		display: none;
	}
`;

export const ApprovalStamp = styled.img`
	margin-top: 20px;
	translate: 40px 0;
	max-width: 300px;
	place-self: center;

	@media ${devices.tablet} {
		scale: 0.9;
		margin-top: 0;
		translate: 30px 0;
		align-self: flex-start;
	}
`;

export const HelpLink = styled(Link)`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	position: absolute;
	bottom: 20px;
	right: 20px;

	color: #595959;
	font-size: 14px;
	line-height: 17px;
	text-align: center;
	text-decoration: none;

	&:hover {
		text-decoration: underline;
	}

	@media ${devices.tablet} {
		bottom: 10px;
		right: 10px;
	}
`;
